import { createContext, useContext } from "react";

const ChatAppContext = createContext(null);

export function ChatAppProvider({ value, children }) {
  if (!value) {
    throw new Error("ChatAppProvider requires a value prop.");
  }
  return (
    <ChatAppContext.Provider value={value}>
      {children}
    </ChatAppContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useChatApp() {
  const context = useContext(ChatAppContext);
  if (!context) {
    throw new Error("useChatApp must be used within ChatAppProvider.");
  }
  return context;
}
